import { makeStyles } from "@material-ui/core";
import React from "react";
const useStyles = makeStyles((theme) => ({
    root: {
        paddingRight: theme.spacing(0),
        paddingLeft: theme.spacing(0)
    }
}));
export const TabPanel = ({ value, index, children }) => {
    const classes = useStyles();
    return (React.createElement("div", { className: classes.root, role: "tabpanel", hidden: value !== index, id: `tabpanel-${index}`, "aria-labelledby": `tab-${index}` }, children));
};
//# sourceMappingURL=TabPanel.js.map